module.exports = __webpack_public_path__ + "static/media/035.39b4c556.jpg";